var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHisunPrimaryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "67.209mm",
    height: "16.5775mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 12367.41 3050.5",
    fill: "#ccc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M9469.12 135.07l0 2804.05c0,101.08 8.56,105.22 107.83,105.22 1075.27,0 946.55,66.08 943.9,-234.38 -1.9,-217.74 -14.13,-947.62 10.54,-1073.39 85.25,7.71 51.65,18.48 156.26,156.85 54.1,71.62 84.26,109.01 138.69,184.42l570.76 766.47c242.83,247.46 479.76,200.02 854.14,200.02 109.54,0 105.46,-21.42 105.46,-126.79 0,-685.12 27.16,-2292.71 -5.02,-2873.07 -120.57,-44.95 -880.18,-26.88 -1018.79,-12.02l-12.72 1258.01c-96.33,3.5 -205.95,-199.29 -305.81,-328.24 -293.93,-379.64 -606.9,-932.38 -1027.59,-932.38 -442.54,0 -517.65,-47.31 -517.65,105.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M6333.51 178.2l0 2609.93c0,173.64 70.74,248.01 245.27,248.01l1693.21 0c633.71,0 930.16,-475.99 930.16,-1110.82l0 -1725.58c0,-135.62 4.12,-177.9 -142.87,-177.9l-734.03 0c-122.63,0 -144.97,14.24 -144.97,134.79l0 1445.17c0,570.52 4.53,531.25 -674.01,531.25 -129.95,0 -149.66,16.14 -155.6,-118.43 -19.19,-434.18 43.02,-1717.77 -11.59,-1975.21 -272.12,-43.32 -569.51,-18.31 -846.59,-17.57 -134.92,0 -158.97,19.14 -158.97,156.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M4710.25 2119.48c-5.34,3.44 -13.87,0.72 -17.24,8.12l-55.72 17.35c-247.02,39.54 -1329.19,-77.91 -1371.09,47.62 -32.92,98.63 -16.14,757.38 -6.53,830.2 174.59,29.92 2043.37,9.26 2391.61,10.78 324.93,1.44 443.4,-41.84 445.17,-373.9 3.48,-655.59 -3.92,-437.57 -362.42,-816.89l-634.72 -572.87c-93.28,-79.31 -392.76,-326.83 -428.77,-401.45 43.81,-26.66 104.06,-28.52 160.39,-28.47 216.03,0.24 1190.19,32.59 1246.27,-17.43l14.81 -780.4c-114.25,-46.83 -1986.05,-16.43 -2382.03,-17.68 -317.54,-0.98 -459.17,8.74 -459.01,347.44 0.35,598.67 -11.45,413.2 396.88,796.17l527.92 463.48c46.81,41.18 74.49,54.34 119.81,96.55 83.38,77.71 381,317.81 414.66,391.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M0.4 3031.51c201.66,2.98 833.66,1.44 1046.29,-1.82l6 -1068.53c183.79,-0.81 709.28,-3.46 810.75,0.74l5.26 1069.97 1029.36 -1.36 -7.16 -1999.26c-405,-6.88 -1498.13,-0.64 -1829.56,-0.4l-11.04 -1022.95c-96.33,-11.48 -1050.33,-8.13 -1050.28,-4.09 0.39,27.75 2.36,2747.33 0.39,3027.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1862.52 133.06l6.68 678.81 1027.48 -2.69c20.08,-186.33 8.13,-497.76 7.86,-697.89 0,-83.91 14.5,-103.45 -70.77,-103.45l-870.63 0c-96.42,0 -100.62,32.11 -100.62,125.22z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHisunPrimaryLogo);
export default ForwardRef;